import RoleTemplatePortalRoleLnkHashTableTypes from "../types/hashTableTypes/RoleTemplatePortalRoleLnkHashTableTypes"
import PortalRoleTemplatePortalRoleLnkTypes from "../types/portalTemplateTypes/PortalRoleTemplatePortalRoleLnkTypes"
import PortalRoleTemplateWithLnksTypes from "../types/portalTemplateTypes/PortalRoleTemplateWithLnksTypes"
import PortalRoleTemplatePortalRoleLnkBoilerplate from "./boilerPlates/templateBoilerplates/PortalRoleTemplatePortalRoleLnkBoilerplate"
import ratmHash from "./RATMHash"
import dayjs from "dayjs"

const { getStorage } = ratmHash

const saveTemplateSetup = (templateToAddOrUpdate: PortalRoleTemplateWithLnksTypes) => {
    const links: RoleTemplatePortalRoleLnkHashTableTypes[] = getStorage(2).filter(n => n)
    let newPortalRoleLinks: PortalRoleTemplatePortalRoleLnkTypes[] = []
    let updatedTemplate = { ...templateToAddOrUpdate }
    for (let i = 0; i < links.length; i++) {
        const bucket = links[i]
        for (let j = 0; j < bucket.length; j++) {
            const link: any = bucket[j]
            if (!link[1].RoleTemplatePortalRoleLnk.RoleTemplatePortalRoleLnkId || link[3].modified) {
                const permissions = link[2].permissions
                let newPortalRoleLink: PortalRoleTemplatePortalRoleLnkTypes = JSON.parse(JSON.stringify(PortalRoleTemplatePortalRoleLnkBoilerplate))
                const canEdit = ((permissions.addEdit || permissions.hasEdit) && !permissions.dropEdit) ? true : false
                const canView = ((permissions.addView || permissions.hasView) && !permissions.dropView) ? true : false
                newPortalRoleLink.RoleTemplatePortalRoleLnkId = link[1].RoleTemplatePortalRoleLnk.RoleTemplatePortalRoleLnkId
                newPortalRoleLink.Edit = canEdit
                newPortalRoleLink.View = canView
                newPortalRoleLink.RoleTemplateId = templateToAddOrUpdate.Template.RoleTemplateId
                newPortalRoleLink.PortalRoleId = parseInt(link[0])
                newPortalRoleLink.RoleTemplatePortalRoleLnkId = link[1].RoleTemplatePortalRoleLnk.RoleTemplatePortalRoleLnkId
                newPortalRoleLink.DeletedDateUTC = permissions.dropRole ? dayjs().format() : null
                newPortalRoleLinks.push(newPortalRoleLink)
            }
        }
    }

    updatedTemplate.RoleTemplatePortalRoleLnk = newPortalRoleLinks

    return updatedTemplate
}

export default saveTemplateSetup